import { Badge } from '@mantine/core';

export default Badge.extend({
  defaultProps: {
    autoContrast: true,
    color: 'dark.0',
  },
  styles: {
    label: {
      textTransform: 'capitalize',
    },
  },
});
